module.exports = __webpack_public_path__ + "static/img/indirect324.32ad287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indirect324.jpg
// module id = +voQ
// module chunks = 3